/* Products the RFP Filler can answer for — one entry per top-level RKB product key.
 *
 * `key`    matches the RKB top-level section name (rkb-data.js).
 * `chip`   short label for header/log/export.
 * `prompt` full name the model is told to describe in every capability answer.
 * `name` / `sub` are the product-card face.
 */

export const PRODUCTS = [
  {
    key: 'infor_csi',
    chip: 'Infor CSI',
    prompt: 'Infor CloudSuite Industrial (CSI)',
    name: 'Infor CSI',
    sub: 'CloudSuite Industrial',
  },
  {
    key: 'acumatica',
    chip: 'Acumatica',
    prompt: 'Acumatica Cloud ERP',
    name: 'Acumatica',
    sub: 'Cloud ERP',
  },
  {
    key: 'infor_visual',
    chip: 'Infor VISUAL',
    prompt: 'Infor VISUAL',
    name: 'Infor VISUAL',
    sub: 'Discrete ERP',
  },
  {
    key: 're_man',
    chip: 'Re-Man',
    prompt: 'Re-Man (WM Synergy remanufacturing solution built on Infor CSI)',
    name: 'Re-Man',
    sub: 'Reman on Infor CSI',
  },
  {
    key: 'ishop',
    chip: 'iShop',
    prompt: 'iShop (WM Synergy B2B/B2C eCommerce storefront and customer portal for Infor CSI/SyteLine)',
    name: 'iShop',
    sub: 'B2B eCommerce & Portal',
  },
];

export const PRODUCT = Object.fromEntries(PRODUCTS.map((p) => [p.key, p]));
